module.exports = __webpack_public_path__ + "assets/img/wback2.b1e44753.png";